// extracted by mini-css-extract-plugin
module.exports = {"logoQuickly":"src-containers-Authentication-LoginQuickly_logoQuickly--q-iVSfN_","button":"src-containers-Authentication-LoginQuickly_button--2rsu32SQ"};